var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowButtonLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E85626"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1625 17.3448C28.0564 17.2355 27.9302 17.1488 27.7912 17.0896C27.6522 17.0305 27.503 17 27.3524 17C27.2018 17 27.0527 17.0305 26.9136 17.0896C26.7746 17.1488 26.6484 17.2355 26.5423 17.3448L20.8375 23.1725C20.7306 23.2808 20.6457 23.4097 20.5877 23.5518C20.5298 23.6938 20.5 23.8461 20.5 24C20.5 24.1539 20.5298 24.3062 20.5877 24.4482C20.6457 24.5903 20.7306 24.7192 20.8375 24.8275L26.5423 30.6552C26.6484 30.7645 26.7746 30.8512 26.9136 30.9104C27.0527 30.9695 27.2018 31 27.3524 31C27.503 31 27.6522 30.9695 27.7912 30.9104C27.9302 30.8512 28.0564 30.7645 28.1625 30.6552C28.2694 30.5469 28.3543 30.418 28.4123 30.2759C28.4702 30.1339 28.5 29.9816 28.5 29.8277C28.5 29.6738 28.4702 29.5215 28.4123 29.3795C28.3543 29.2374 28.2694 29.1085 28.1625 29.0002L23.2563 24L28.1625 18.9998C28.2694 18.8915 28.3543 18.7626 28.4123 18.6205C28.4702 18.4785 28.5 18.3262 28.5 18.1723C28.5 18.0184 28.4702 17.8661 28.4123 17.7241C28.3543 17.582 28.2694 17.4531 28.1625 17.3448Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowButtonLeft);
export default __webpack_public_path__ + "static/media/arrow-button-left.d8c205d186913b1606875cc4d66cb23e.svg";
export { ForwardRef as ReactComponent };